<template>
  <section id="login">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>

    <div style="margin-top:150px; margin-bottom:150px">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>

          <form style="padding:10px; margin:30px">
            <h3 style="text-align:center; padding-bottom:15px">Nueva categoría</h3>

            <div class="form-group">
              <label>Nombre de la categoría</label>
              <input class="form-control" v-model="newCategory.nombre" />
            </div>

            <div class="form-group">
              <label>Link a la imagen</label>
              <input class="form-control" v-model="newCategory.imagen" />
            </div>

            <div class="form-group">
              <label>Color en hexadecimal (sin #)</label>
              <input class="form-control" v-model="newCategory.color" />
            </div>

            <div class="form-group">
              <label>Link al video</label>
              <input class="form-control" v-model="newCategory.video" />
            </div>

            <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>

            <div style="text-align:center">
              <button
                type="button"
                class="btn btn-primary"
                @click="altaCategoria(newCategory)"
              >Crear categoría</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";

export default {
  name: "app",

  data() {
    return {
      errorMessage: "",
      habilitado: false,

      newCategory: {
        nombre: "",
        imagen: "",
        color: "",
        video: ""
      }
    };
  },

  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },

  methods: {
    altaCategoria(categoria) {
      self = this;
      self.errorMessage = "";

      fetch(this.pathAPI + "categorias.php", {
        method: "POST",
        body:
          "usuario=" +
          this.userLogged.usuario +
          "&descripcion=" +
          categoria.nombre +
          "&color=" +
          categoria.color +
          "&imagen_categoria=" +
          categoria.imagen +
          "&link_video=" +
          categoria.video,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {

            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
            } else {
              console.log(result)
              self.$store.state.categorias.push({
                id: result.id_categoria,
                nombre: categoria.nombre,
                imagen: categoria.imagen,
                styleObject: { backgroundColor: "#" + categoria.color },
                color: "#" + categoria.color,
                video: categoria.link_video,
                estado: "B"
              });
              self.$router.push({ path: "/Categorias" });
            }
          });
        } else {
          self.errorMessage = "Hay un error, verificá los datos ingresados";
        }
      });
    },
    volver() {
      this.$router.push({ path: "/Categorias" });
    }
  },

  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
    }
    const loader = document.querySelector(".loader");
    loader.className += " hidden";
  }
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-modal-admin.svg");
  background-repeat: repeat-x;
  background-size: 1000px;
  display: table;
  width: 100%;
  background-position-y: top;
}
.login {
  width: 500px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}
.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/categories/NewCategory.vue